import React, { useEffect, useState } from "react";
import InputBox from "../../components/Input/Input";
import Label from "../../components/Label/Label";
import { SideBar } from "../../components/SideBar/SideBar";
import useAuthService from "../../auth/AuthService";
import { GetNotifications, ToggleNotification } from "../../services/notification.service";
import { handleMessage } from "../../utils/handleMessagePopup";

interface NotificationProps {
  userRole: string;
}

const Notification: React.FC<NotificationProps> = ({ userRole }) => {
  const { isAuthenticated, getToken } = useAuthService();
  // State for checkboxes
  const [state, setState] = useState({
    isLoading: false,
    email_notifications: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isAuthenticated) {
          handleToggle("isLoading", true)
          const res = await GetNotifications(getToken)
          if (res.error === null && res.data !== null) {
            setState((prev) => ({ ...prev, email_notifications: res.data.email_notifications }))
          }
        }
      } catch (err) {
        handleToggle("isLoading", false)
      } finally {
        handleToggle("isLoading", false)
      }
    }
    fetchData();
    //eslint-disable-next-line
  }, [])

  // Function to handle checkbox changes
  const handleCheckboxChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    try {
      if (isAuthenticated) {
        handleToggle("isLoading", true)
        const res = await ToggleNotification({ notification_type: id, value: checked }, getToken)
        if (res.data !== null && res.error === null) {
          setState((prevState) => ({
            ...prevState,
            [id]: checked,
          }));
          handleMessage("Notification settings updated successfully.")
        } else {
          handleMessage("Failed to update settings.")
        }
      }
    } catch {
      handleToggle("isLoading", false)
    } finally {
      handleToggle("isLoading", false)
    }
  };

  const handleToggle = (key: keyof typeof state, value?: boolean) => {
    setState((pre) => ({ ...pre, [key]: value ? value : !pre[key] }));
  };

  return (
    <>{state.isLoading ?
      <div className="loader">
        <div className="spinner"></div>
      </div> : <></>}
      <div className="container profile-page ps-2">
        <div className="edit-profile-header py-4">Settings</div>
        <div className="notification-details">
          <div className="side-bar">
            <SideBar ActiveItem="notifications" userRole={userRole} />
          </div>
          <div className="page-content">
            <div className="profile-content notification-content">
              <div className="heading">Notifications</div>
              <> {/* <div className="row my-4">
              <div className="sub-heading">Push Notifications</div>
              <div className="col-lg-5 col-10 custom-formcheck">
                <div className="rowdata">
                  <Label
                    className="detail-left p-0"
                    text="Private and Public Messages"
                  />
                  <div className="form-check py-0 position-relative">
                    <InputBox
                      className={`form-check-input check-input ${
                        !notifications.privateMessages ? "border-white" : ""
                      }`}
                      type="checkbox"
                      id="privateMessages"
                      checked={notifications.privateMessages}
                      onChange={handleCheckboxChange}
                    />
                    <div
                      className={`${
                        !notifications.privateMessages
                          ? "circle border-white"
                          : "circle-checked"
                      }`}
                    ></div>
                  </div>
                </div>
                <div className="rowdata">
                  <Label
                    className="detail-left p-0"
                    text="Auction Notifications"
                  />
                  <div className="form-check border-white py-0 position-relative">
                    <InputBox
                      className={`form-check-input check-input ${
                        !notifications.auctionNotifications
                          ? "border-white"
                          : ""
                      }`}
                      type="checkbox"
                      id="auctionNotifications"
                      checked={notifications.auctionNotifications}
                      onChange={handleCheckboxChange}
                    />
                    <div
                      className={`${
                        !notifications.auctionNotifications
                          ? "circle border-white"
                          : "circle-checked"
                      }`}
                    ></div>
                  </div>
                </div>
                <div className="rowdata">
                  <Label
                    className="detail-left p-0"
                    text="Following Notifications"
                  />
                  <div className="form-check py-0 position-relative">
                    <InputBox
                      className={`form-check-input check-input ${
                        !notifications.followingNotifications
                          ? "border-white"
                          : ""
                      }`}
                      type="checkbox"
                      id="followingNotifications"
                      checked={notifications.followingNotifications}
                      onChange={handleCheckboxChange}
                    />
                    <div
                      className={`${
                        !notifications.followingNotifications
                          ? "circle border-white"
                          : "circle-checked"
                      }`}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="sub-heading">SMS Notifications</div>
              <div className="col-lg-5 col-10 custom-formcheck">
                <div className="rowdata">
                  <Label
                    className="detail-left p-0"
                    text="Private and Public Messages"
                  />
                  <div className="form-check py-0 position-relative">
                    <InputBox
                      className={`form-check-input check-input ${
                        !notifications.smsPrivateMessages ? "border-white" : ""
                      }`}
                      type="checkbox"
                      id="smsPrivateMessages"
                      checked={notifications.smsPrivateMessages}
                      onChange={handleCheckboxChange}
                    />
                    <div
                      className={`${
                        !notifications.smsPrivateMessages
                          ? "circle border-white"
                          : "circle-checked"
                      }`}
                    ></div>
                  </div>
                </div>
                <div className="rowdata">
                  <Label
                    className="detail-left p-0"
                    text="Auction Notifications"
                  />
                  <div className="form-check py-0 position-relative">
                    <InputBox
                      className={`form-check-input check-input ${
                        !notifications.smsAuctionNotifications
                          ? "border-white"
                          : ""
                      }`}
                      type="checkbox"
                      id="smsAuctionNotifications"
                      checked={notifications.smsAuctionNotifications}
                      onChange={handleCheckboxChange}
                    />
                    <div
                      className={`${
                        !notifications.smsAuctionNotifications
                          ? "circle border-white"
                          : "circle-checked"
                      }`}
                    ></div>
                  </div>
                </div>
                <div className="rowdata">
                  <Label
                    className="detail-left  p-0"
                    text="Following Notifications"
                  />
                  <div className="form-check py-0 position-relative">
                    <InputBox
                      className={`form-check-input check-input ${
                        !notifications.smsFollowingNotifications
                          ? "border-white"
                          : ""
                      }`}
                      type="checkbox"
                      id="smsFollowingNotifications"
                      checked={notifications.smsFollowingNotifications}
                      onChange={handleCheckboxChange}
                    />
                    <div
                      className={`${
                        !notifications.smsFollowingNotifications
                          ? "circle border-white"
                          : "circle-checked"
                      }`}
                    ></div>
                  </div>
                </div>
              </div>
            </div> */}</>
              <div className="my-4">
                <div className="sub-heading">Email Notifications</div>
                <div className="custom-formcheck">
                  <div className="rowdata align-items-center">
                    <Label
                      className="detail-left p-0"
                      text="Receive notifications in email"
                    />
                    <InputBox checked={state.email_notifications}
                      onChange={handleCheckboxChange} id="email_notifications" type="toggle" className="input-slider input-round" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notification;
